export enum SupportedLocale {
  FrFR = "fr-FR",
  EnGB = "en-GB",
}
